<template>
  <div>
    <!--右侧内容-->
    <modals-container name="modal1" />
    <v-dialog/>
    <div class="class_add_top">
      <a class="back" onclick="history.go(-1)">返回</a>
      <span v-if="isEdit">编辑</span><span v-if="!isEdit">新增</span>文章
    </div>
    <div class="class_add_con">
      <form data-vv-scope="form">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tr class="tita">
            <td class="left_td">文章信息</td>
            <td>&nbsp;</td>
          </tr>
          <tr>
            <td class="left_td pt20">标题：</td>
            <td class="pt20">
              <input type="text" name="title" v-validate="'required'" v-model="params.title" placeholder="60字以内" v-bind:maxlength="60" class="put_495" />
              <div class="error_msg_tip">{{ errors.first('form.title') }}</div>
            </td>
          </tr>
          <tr>
            <td class="left_td pt20">编号：</td>
            <td class="pt20">
              <input type="text" name="no" v-model="params.no" placeholder="编号" v-bind:maxlength="60" class="put_495" />
              <div class="error_msg_tip">{{ errors.first('form.no') }}</div>
            </td>
          </tr>
          <tr>
            <td class="left_td pt20" valign="top">封面：</td>
            <td valign="top" class="rdiv pt20">
              <img v-if="params.cover && params.cover!==''" :src="params.cover"  class="upload_con" />
              <UploadOSS :uploadOSSConf="uploadOSSConf_R" :DOM_ID="'cover'" v-if="uploadOSSConf_R.STS!=null"  @success = "OSSUploadSuccessR"></UploadOSS>
              <p class="mt10"><span class="tips_text">建议图片长500px宽500px，支持jpg、jpeg、png，图片大小不超过2MB</span></p>
            </td>
          </tr>
          <tr>
            <td class="left_td pt20" valign="top">默认分类：</td>
            <td class="pt20 rdiv">
              <div class="treeSelect">
                <treeselect
                  :options="options"
                  :value="classification"
                  valueFormat = "object"
                  value-consists-of="ALL_WITH_INDETERMINATE"
                  :searchable="false"
                  :show-count="true"
                  placeholder="--请选择分类--"
                  v-model="classification"
                >
                </treeselect>
              </div>
            </td>
          </tr>
          <tr>
            <td class="left_td pt30" valign="top">简介：</td>
            <td valign="top" class="pt30 rdiv">
              <textarea name="brief" cols="" rows="" class="text_area w490 h70" v-model="params.brief" v-bind:maxlength="200" placeholder="200字以内"></textarea>
              <div class="error_msg_tip">{{ errors.first('form.brief') }}</div>
              <p class="mt10"><span class="tips_text">简介字数不能超过200字</span></p>
            </td>
          </tr>
          <tr>
            <td class="left_td">是否公开：</td>
            <td>
              <input name="address" type="radio" v-model="params.isOpen" value="0" />
              公开
              <input name="address" type="radio" v-model="params.isOpen" value="1" />
              不公开&nbsp;&nbsp;&nbsp;&nbsp;
            </td>
          </tr>
          <tr>
            <td class="left_td pt30" valign="top">内容：</td>
            <td valign="top" class="pt30">
              <Ueditor :value="ueditor.value" :config="ueditor.config" ref="ue"></Ueditor>
            </td>
          </tr>
          <div class="error_msg" v-if="contentFlag">内容不能为空</div>
          <tr>
            <td class="left_td pt30" valign="top">附件：</td>
            <td valign="top" class="pt30">
              <span v-if="uploadFiles && uploadFiles.length > 0"><input type="radio" style="opacity: 1; cursor: pointer;" v-model="params.readFile" value="0"> 不读取文件</span>
              <span v-if="uploadFiles && uploadFiles.length > 0"><input type="radio" style="opacity: 1; cursor: pointer;" v-model="params.readFile" value="1"> 读取文件</span>
              <div class="all_btn" v-if="uploadFiles && uploadFiles.length > 0 && params.readFile == '1'" style="display: inline-block; cursor: pointer; vertical-align: middle;" @click="show1">选择附件</div>
              <div v-if="uploadFiles && uploadFiles.length > 0 && params.readFile == '1'" style="display: inline-block; vertical-align: middle">{{tmpFile.name}}</div>
              <upload-o-s-s-elem v-if="uploadOSSConf.STS!=null" :files="uploadFiles" :uploadOSSConf="uploadOSSConf" @success = "OSSUploadSuccess" @preview="handlePreview" @remove="handleRemove"></upload-o-s-s-elem>
              <!--input id="kb-files" type="file" multiple="multiple" @change="changed">
              <li v-for="item in uploadFiles" :key="item.name">
                文件名: {{item.name}},
                大小: {{item.size}}
              </li-->
            </td>
          </tr>
        </table>
        <p class="btn_center">
          <input type="button" class="all_btn" value="保存提交" @click="editResource('form')"/>
        </p>
      </form>
    </div>
    <!--/右侧内容-->
  </div>
</template>
<script>

  import Dropdown from '@/store/modules/dropdowns'
  import UploadOSS from '@/components/common/upload/uploadOSS.vue'
  import UploadVod from '@/components/common/upload/uploadVod.vue'
  import UploadOSSElem from '@/components/upload/uploadOSSbyElem'
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import Ueditor from '@/components/common/UE/ue'
  import utils from '@/utils'
  import '@/utils/validator.js'
  import FileSelect from '@/page/byl/org/repo/file-select'
  import { mapActions, mapState } from 'vuex'
  import isempty from 'lodash.isempty'
  import Bus from '@/utils/bus'
  export default {
    components: { Treeselect, UploadVod, UploadOSS, UploadOSSElem, Ueditor },
    data () {
      return {
        Dropdown: Dropdown,
        options: [],
        classification: {
          id: '',
          label: ''
        },
        params: {
          classification: null,
          files: [],
          isOpen: '1',
          readFile: '0',
          readFileIndex: null
        },
        ueditor: {
          value: '',
          config: {
            initialFrameWidth: 790,
            initialFrameHeight: 227
          }
        },
        resourceType: '',
        contentFlag: false,
        RCTree: [],
        uploadOSSConf_R: { showMode: '1', style: 'img_upload', typeArr: 'image/png,image/jpg,image/jpeg', catalog: 'byl', fileName: '', maxSize: '2000000', STS: null },
        uploadOSSConf: { tiptxt: '最多上传三个文件, 一次上传文件的文件请不要超过1G', typeArr: 'image/jpeg, image/png, audio/*, video/mp4, application/pdf, text/plain, application/vnd.ms-powerpoint, application/vnd.ms-excel, application/vnd.ms-works, application/msword, application/octet-stream, application/zip', catalog: 'resource', fileName: '', maxSize: '1048576', STS: null },
        uploadFiles: [],
        tmpFile: {},
        prefix: this.$route.meta.prefix || ''
      }
    },
    created () {
      if (this.$route.params.id === 'create') {
        this.params = {
          isOpen: '1',
          files: [],
          classificationId: null,
          readFile: '0',
          readFileIndex: null
        }
      } else {
        this.getResource(this.$route.params.id)
      }
      this.getResourceClassification()
    },
    mounted () {
      this.getSTS()
      Bus.$on('set-selected-file', (id) => {
        if (id.length > 0) {
          let idx = utils.findElem(this.uploadFiles, 'uid', id[0])
          this.params.readFileIndex = idx
          this.tmpFile = this.uploadFiles[idx]
        } else {
          this.tmpFile = {}
          this.params.readFile = '0'
          this.params.readFileIndex = null
        }
      })
    },
    computed: {
      ...mapState('auth', ['user']),
      isEdit () {
        return this.$route.params.id && this.$route.params.id !== 'create'
      }
    },
    methods: {
      changed () {
        var $raw = document.getElementById('kb-files')
        var t_files = $raw.files;
        var arr = [];
        for (var i = 0, len = t_files.length; i < len; i++) {
          var o = {
            name: t_files[i].name,
            size: t_files[i].size / 1024 + 'KB',
            rawO: t_files[i]
          }
          arr.push(o)
        };
        this.uploadFiles = arr
      },
      popup (msg) {
        this.$toasted.show(msg)
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: '提交',
          text: '确认提交吗？',
          buttons: [
            {
              title: '确认',
              default: false,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      returnContent () {
        return this.$refs.ue.getUEContent()
      },
      setContent (str) {
        this.ueditor.value = this.$refs.ue.setUEContent(str)
      },
      OSSUploadSuccessR (r) {
        if (r && r != '') {
          this.$set(this.params, r.dom_id, r.res.requestUrls[0])
        }
      },
      OSSUploadSuccess (r) {
        if (r && r != '') {
          this.uploadFiles.push({
            name: r.name.split('/')[2],
            url: r.res.requestUrls[0]
          })
        }
      },
      getResource (id) {
        this.$api.post(this.$global.bylApiPath, '/knowledgeInfo/get', {id: id}, r => {
          if (r.data) {
            this.params = r.data
            if (this.params.content) {
              this.setContent(this.params.content)
            }
            if (this.params.files) {
              let f = this.params.files.split(',')
              f.forEach((o) => {
                let obj = {
                  name: o.split('|')[0],
                  url: o.split('|')[1]
                }
                this.uploadFiles.push(obj)
              })
            }
            if (this.params.classificationId) {
              let arr = this.params.classificationId.split(',').filter((o) => {
                return o
              })
              this.classification = {
                id: arr[arr.length-1]
                // parentId: this.params.classificationId.split(',')[1]
              }
            }
            if (this.params.readFile == '1') {
              this.tmpFile = this.uploadFiles[this.params.readFileIndex]
            }
          }
        })
      },
      setClassificationId (o) {
        let result = (o.parentId == '0') ? o.parentId + ',' + o.id + ',' : '0,' + o.parentId + ',' + o.id + ','
        return result
      },
      editResource (scope) {
        var self = this
        // console.log(self.classification)
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            self.params.content = self.returnContent()
            if (self.returnContent()) {
              self.confirmBox({
                yes: function () {
                  if (self.uploadFiles && self.uploadFiles.length > 0) {
                    var arr = []
                    self.uploadFiles.forEach((o) => {
                        arr.push(o.name + '|' + o.url)
                    })
                    self.params.files = utils.arr2str(arr)
                  } else {
                    self.params.files = ''
                  }
                  self.params.classificationId = self.setClassificationId(self.classification)
                  if (self.params.readFile == '1' && isempty(self.tmpFile)) {
                    self.$toasted.show('您设置了"附件读取", 请至少选择一个附件')
                  } else {
                    if (self.params.readFile == '0') {
                      self.params.readFileIndex = null
                    }
                    self.$api.post(self.$global.bylApiPath, '/knowledgeInfo/edit', self.params, r => {
                      self.popup(r.message)
                      self.$router.push({path: self.prefix + '/org/repoList'})
                    })
                  }
                }
              })
            } else {
              self.$toasted.show('内容不能为空')
              self.contentFlag = true
            }
          } else {
            self.$toasted.show('请确保信息正确与完整！', {
              duration: 800
            })
            return false
          }
        })
      },
      dealTree (arr) {
        var dealArr = []
        if (arr && arr.length > 0) {
          for (var i = 0; i< arr.length; i++) {
            var temp = {
              id: arr[i].id,
              label: arr[i].name,
              parentId: arr[i].parentId
            };
            if (arr[i].nodes && arr[i].nodes.length > 0) {
              temp.children = this.dealTree(arr[i].nodes)
            }
            dealArr.push(temp)
          }
        }
        return dealArr
      },
      getResourceClassification () {
        this.$api.get(this.$global.bylApiPath, '/knowledgeClassification/findList', {}, r => {
          let tree = r.data
          this.options = this.dealTree(tree)
        })
      },
      handlePreview (params) {
        let aLink = document.createElement('a')
        aLink.setAttribute('download', params.url)
        aLink.setAttribute('href', params.url)
        aLink.click()
      },
      handleRemove(params) {
        let idx = utils.findElem(this.uploadFiles, 'uid', params.uid)
        if (!isempty(this.tmpFile)) {
          if (params.uid == this.tmpFile.uid) {
            this.tmpFile = {}
            this.params.readFile = '0'
            this.params.readFileIndex = null
          }
        }
        this.uploadFiles.splice(idx, 1)
      },
      getSTS () {
        this.$api.get(this.$global.resourceApiPath, '/common/getSTS', {}, r => {
          let STS = [r.data.expiration, r.data.accessKeyId, r.data.accessKeySecret, r.data.securityToken, r.data.endpointClean, r.data.bucket, r.data.region]
          this.uploadOSSConf.STS = STS
          this.uploadOSSConf_R.STS = STS
        })
      },
      show1 () {
        this.$modal.show(FileSelect, {
          list: this.uploadFiles,
          idx: this.tmpFile.uid || null
        })
      }
    }
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/page/byl/org/repo/model.vue